<ion-app>
  <ion-split-pane when="xl" contentId="main">
    <ion-menu side="start" type="overlay" *ngIf="user && user.userType !== userType.Passenger" contentId="main">
      <ion-header class="menu-header">
        <div class="menu-header__brand">
          <ion-img src="assets/images/logos/gospread.png" class="menu-header__logo"></ion-img>
          <div class="menu-header__greeting">
            <span class="menu-header__title">GoSpread</span>
            <span class="menu-header__hello">Hello, {{ user.userType !== userType.Restaurant ? user.name : user.restaurante }}</span>
          </div>
        </div>
      </ion-header>
      <ion-content class="menu-content">
        <ion-list lines="none" class="menu-list" *ngFor="let section of appSections">
          <div class="menu-section-header" *ngIf="section.header">{{ section.header }}</div>
          <ion-menu-toggle auto-hide="false" *ngFor="let p of section.items">
            <ion-item [routerDirection]="'root'" (click)="actionItem(p)" class="menu-item" [detail]="p.detail || false">
              <ion-icon slot="start" [name]="p.icon" class="menu-item__icon"></ion-icon>
              <ion-label class="menu-item__label">{{p.title}}</ion-label>
              <ion-badge *ngIf="p.badge" slot="end" class="menu-item__badge">{{p.badge}}</ion-badge>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main"></ion-router-outlet>
  </ion-split-pane>
  <app-modal-component *ngIf="modalLink" (stateOpen)="modalLink = $event">
    <app-generate-link></app-generate-link>
  </app-modal-component>
</ion-app>
